
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 9c2.254 0 4.416.961 6.01 2.672 1.595 1.71 2.49 4.03 2.49 6.45C38.5 25.098 33 31 30 31s-8.5-5.902-8.5-12.878c0-2.42.895-4.74 2.49-6.45C25.584 9.962 27.746 9 30 9zm5.5 10.732a4.24 4.24 0 00-1.831.418 4.53 4.53 0 00-1.515 1.181 4.926 4.926 0 00-.935 1.741 5.165 5.165 0 00-.194 1.999 4.24 4.24 0 002.306-.391 4.53 4.53 0 001.515-1.182c.422-.504.74-1.097.935-1.74.194-.645.26-1.326.194-2a4.684 4.684 0 00-.475-.026zm-11 0c-.16 0-.318.009-.475.027a5.16 5.16 0 00.232 2.12 4.89 4.89 0 001.06 1.804A4.47 4.47 0 0027 24.822c.633.24 1.308.325 1.975.249.017-.168.025-.338.025-.51 0-1.28-.474-2.51-1.318-3.415-.844-.905-1.988-1.414-3.182-1.414z","fill":"#fff"}})])
          )
        }
      }
    